/**
 * Labels for Fiti agenda item `status` (e.g. `obterAgendaDia`).
 * Codes come from the gym API; only a subset is documented in-app.
 */

/** API status for a full class ("turma cheia"), confirmed by the gym staff. */
export const CLASS_FULL_STATUS = 6;

export function agendaStatusLabelPt(status: number): string {
  switch (status) {
    case 1:
      return "Disponível";
    case 5:
      return "Inscrito";
    case CLASS_FULL_STATUS:
      return "Turma cheia";
    case 9:
      return "Check-in ainda não liberado";
    default:
      return `Status ${status}`;
  }
}

/** True when the API reports the class as full. */
export function isClassFullStatus(status: number): boolean {
  return status === CLASS_FULL_STATUS;
}
